"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import copy from 'copy-to-clipboard';
import { Button } from '../Button/Button.mjs';
import 'react';
import '@tabler/icons-react';
import '../Icon/Icon.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { IconCopy } from '../Icon/components/icons/IconCopy.mjs';
import locales from '../../../../_virtual/_.locale.json@51592c7dce2c58889664b6822f25f6d1.mjs';
import { useLocalizedStringFormatter } from 'react-aria';
import { TooltipTrigger } from '../Tooltip/components/TooltipTrigger/TooltipTrigger.mjs';
import { Tooltip } from '../Tooltip/Tooltip.mjs';
import { onlyText } from 'react-children-utilities';
import { ClearPropsContext } from '../ClearPropsContext/ClearPropsContext.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { Action } from '../Action/Action.mjs';

const CopyButton = flowComponent("CopyButton", (props) => {
  const {
    text,
    ref,
    variant = "plain",
    color = "secondary",
    ...buttonProps
  } = props;
  const stringFormatter = useLocalizedStringFormatter(locales);
  const tooltip = stringFormatter.format("copyButton.copy");
  const copyValue = () => {
    copy(onlyText(text));
  };
  return /* @__PURE__ */ jsx(ClearPropsContext, { children: /* @__PURE__ */ jsxs(TooltipTrigger, { children: [
    /* @__PURE__ */ jsx(Action, { action: copyValue, showFeedback: true, children: /* @__PURE__ */ jsx(
      Button,
      {
        "aria-label": tooltip,
        ...buttonProps,
        ref,
        variant,
        color,
        children: /* @__PURE__ */ jsx(IconCopy, {})
      }
    ) }),
    /* @__PURE__ */ jsx(Tooltip, { children: tooltip })
  ] }) });
});

export { CopyButton, CopyButton as default };
//# sourceMappingURL=CopyButton.mjs.map
